<app-spinner name="manage-request"></app-spinner>
<div>
  <app-alert *ngIf="showErrorMessage" [message]="showErrorMessage" [msgtype]="'error'" [messageHeading]="'Error'"></app-alert>
</div>
<div *ngIf="!isRequestSuccess">
  <div class="mtb-20">
    <h3>Manage Request</h3>
  </div>
  <div class="mb-30">
    <div class="card fluid">
      <div class="card__content border-bottom border-gray-600">
        <div class="width-full">
          <div class="mtb-10">
            <b>Current Role Requests</b>
          </div>
          <div>
            Review, approve, and deny application role requests from people in your organization. Check the appropriate check box for each request, then click the Submit Role Updates button.
          </div>
          <div class="mt-10">
            <button class="secondary border-blue rounded-4 hover-blue-200" [class.disabled]="!requests?.length" (click)="showModal = true" title="Select All for Approval">
              <div class="btn-txt font-blue">
                <i class="fa-solid fa-circle-check fa-lg mr-10"></i>
              </div>
              <div class="btn-txt font-blue bold">Select All for Approval</div>
            </button>
          </div>
          <div>
            <ul class="requests-legend">
              <li class="font-gray-700">
                <div class="display-inline-block">
                  <div>
                    <i class="fa-solid fa-circle-check"></i>
                  </div>
                  <div>
                    <i class="fa-solid fa-ban"></i>
                  </div>
                  <div>Role(s)</div>
                </div>
              </li>
            </ul>
          </div>

          <!-- Loop through user requests -->
          @for (request of requests; track request) {
            <div class="mt-10">
              <div>
                <a placement="right" tooltip="Click here to see requestor contact information." (click)="clickOnUser(request)">
                  {{ request.firstName }} {{ request.lastName }}
                  <i [ngClass]="(!request?.expanded) ? 'fa-solid fa-caret-down' : 'fa-solid fa-caret-up'"></i>
                </a>
              </div>
              @if (selectedReq === request && selectedReq.expanded) {
                <app-person-details-dialog [request]="request" (onClose)="onCloseAlert()"></app-person-details-dialog>
              }
              @for (role of request.rolesRequested; track role) {
                <ul class="requests">
                  <li>
                    <div class="flex" style="justify-content: space-between;">
                      <div class="flex align-request-ui">
                        <div class="lrg">
                          <input type="checkbox" id="approve1" name="accept" placement="right" tooltip="Check to approve role request." title="Approve Role Request" [checked]="role?.isAccept" (change)="onAccept($event, role)">
                        </div>
                        <div class="lrg">
                          <input type="checkbox" id="reject" name="reject" placement="right" tooltip="Check to decline role request." [checked]="role?.isReject" (change)="onReject($event, role)" title="Decline Role Request">
                        </div>
                        <div>
                          {{ role.roleName }} - {{ role.orgName }}
                        </div>
                      </div>
                      <div class="history-expand">
                        @if (!role?.showHistory) {
                          <i placement="left" tooltip="Click to view history of role request" (click)="clickOnHistoryExpand(role)" [ngClass]="(!role.showHistory) ? 'fa-solid fa-angle-down' : 'fa-solid fa-angle-up'"></i>
                        } @else {
                          <i (click)="clickOnHistoryExpand(role)" [ngClass]="'fa-solid fa-angle-up'"></i>
                        }
                      </div>
                    </div>
                    <!-- Show role history if expanded -->
                    @if (role.showHistory) {
                      <div style="padding: 16px; background-color: white;">
                        <table class="table-ode">
                          <thead>
                            <tr>
                              <th>History</th>
                              <th>Person</th>
                              <th>Comment</th>
                              <th>Date</th>
                            </tr>
                          </thead>
                          <tbody>
                            @for (history of role.history; track history) {
                              <tr>
                                <td>Role Request {{history.toWorkflowStateName}}</td>
                                <td>{{history.updatePersonFirstName}} {{history.updatePersonLastName}}</td>
                                <td>{{history.workflowComment}}</td>
                                <td>{{history.updateTs | date: 'MM/dd/yyyy hh:mm a'}}</td>
                              </tr>
                            }
                            @if (!role.history?.length) {
                              <tr>
                                <td colspan="3" class="text-center bold">No role History found</td>
                              </tr>
                            }
                          </tbody>
                        </table>
                        <div class="block">
                          <div class="flex gap-20 justify-end mt-10">
                            <button class="secondary border-red rounded-4 hover-red hover-font-white flex-row-reverse" (click)="role.showHistory = false">
                              <div class="btn-txt font-red bold">Close</div>
                            </button>
                          </div>
                        </div>
                      </div>
                    }
                    <!-- Show role update fields if selected -->
                    @if (role.showCommentsSection && (role.isReject || role.isAccept)) {
                      <div class="mt-10 fade">
                        <div class="inline-text-field-container">
                          <div class="mb-5"><span style="color: red;font-size: 24px;">{{ role.isAccept ? '' : '*' }}</span>Reason for Role {{ role.isAccept ? 'Approval' : 'Decline' }}</div>
                          <div class="text-area-container" [ngClass]="role.isReject? 'mandatory' : ''">
                            <label for="reason" class="ds-floating-label text-area">Reason</label>
                            <textarea class="textarea gray" name="reason" required [(ngModel)]="role.reason" rows="3"></textarea>
                          </div>
                        </div>
                      </div>
                      <div class="inline-text-field-container even-cols flex-row gap-20 mt-10">
                        <div class="ds-text-field gray">
                          <input class="ds-text-field__input" id="effectiveDate" type="date" name="effectiveDate" [min]="today" [(ngModel)]="role.effectiveDate" required>
                          <label for="effectiveDate" class="ds-floating-label">*Effective Date</label>
                        </div>
                      </div>
                      <div class="block">
                        <div class="flex gap-20 justify-end mt-10">
                          <button class="secondary border-red rounded-4 hover-red hover-font-white flex-row-reverse" (click)="onCancel(role)">
                            <div class="btn-txt font-red bold">Cancel</div>
                          </button>
                          <button class="rounded-4 hover-blue-800 black" (click)="addComment(role)">
                            <div class="btn-txt font-white bold">Add Comment</div>
                          </button>
                        </div>
                      </div>
                    }
                  </li>
                </ul>
              }
            </div>
          }

          <!-- Display stats for requests -->
          <div class="mt-10">
            <ul class="info totals">
              <li>
                <div class="bold font-red">{{ getStats('unselected') }}</div>
                <div class="font-red">Unselected Requests</div>
              </li>
              <li>
                <div><i class="fa-solid fa-circle-check"></i></div>
                <div class="bold">{{ getStats('approve') }}</div>
                <div>Selected For Approval</div>
              </li>
              <li>
                <div><i class="fa-solid fa-ban"></i></div>
                <div class="bold">{{ getStats('reject') }}</div>
                <div>Selected To Be Declined</div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container flex mobile border-top border-gray-600 mt-20 pt-10">
    <span class="basis-50">
      <span class="flex justify-start">
        <button [routerLink]="['../']" class="secondary border-red rounded-4 hover-red hover-font-white flex-row-reverse mobile">
          <div class="btn-txt font-red bold">Back</div>
        </button>
      </span>
    </span>
    <span class="basis-50">
      <span class="flex justify-end">
        <button class="rounded-4 hover-blue-800 black mobile" (click)="submitRoleUpdate()" [routerLink]="['./role-request-success']"  [class.disabled]="!atleastOneRoleSelected">
          <div class="btn-txt font-white bold">Submit Role Updates</div>
        </button>
      </span>
    </span>
  </div>

</div>

<!-- Modal for Select All Approval -->
@if (showModal) {
  <div id="modal-popup" class="modal-wrapper modal-open" style="visibility: visible; opacity: 100" role="dialog" aria-labelledby="modal-1-heading" aria-describedby="modal-1-description">
    <div class="modal-body rounded-20 white text-center relative shadow">
      <div class="modal-content">
        <header>
          <div class="modal-title" id="modal-1-heading">
            <i class="fa-solid fa-check-circle"></i> Approve All
          </div>
        </header>
        <p class="font-18 bold font-gray-700" id="modal-1-description">
          If you choose to approve all requests, please be aware that all effective dates and reasons will be the same. If you would like to change dates, reasons, or decline a request, you may edit the role individually after selecting "Approve All".
        </p>
        <div class="p-20">
          <div class="mt-20 mb-10" style="text-align: left;">
            Reason for role approval
          </div>
          <div class="inline-text-field-container ds-text-field">
            <div class="text-area-container">
              <textarea class="textarea p-10" maxlength="4000" name="reason" rows="8" placeholder="Reason" [(ngModel)]="modalDtls.reason" style="background-color: #f2f2f2;"></textarea>
            </div>
          </div>
          <div style="width: 30%;">
            <div class="inline-text-field-container ds-text-field mt-20" style="background-color: #f2f2f2;">
              <input class="ds-text-field__input date" id="effdate" type="date" name="effectiveDate" [min]="today" [(ngModel)]="modalDtls.effectiveDate">
              <label for="effdate" class="ds-floating-label">*Effective Date</label>
            </div>
          </div>
        </div>
        <div class="modal-button-container button-adjust" style="justify-content: right;width: 90%;">
          <button class="secondary border-red rounded-full hover-red hover-font-white flex-row-reverse mobile" (click)="showModal = false">
            <div class="btn-txt font-red bold">Cancel</div>
          </button>
          <button class="black rounded-full hover-blue-800 mobile" type="submit" (click)="selectAllForApprove()">
            <div class="btn-txt font-white bold">Approve All</div>
          </button>
        </div>
      </div>
    </div>
  </div>
}

<app-role-request-success *ngIf="isRequestSuccess" message="Your role request actions were processed."></app-role-request-success>